import axios from '@axios'
export const state = {
    mtrouters: [],
    currentPage: 1,
    perPage: 15,
    totalPage: 1,
    totalRecords: 1
}

export const getters = {
    allMtRouters: state => state.mtrouters,
    currentPage: (state) => state.currentPage,
    totalPage: (state) => state.totalPage,
    perPage: state => state.perPage,
    totalRecords: state => state.totalRecords
}

export const mutations = {
    GET_MT_ROUTERS: (state, data) => {
        state.mtrouters = data.routes
        state.currentPage = data.page
        state.totalPage = data.totalPages
        state.perPage = data.perPage
        state.totalRecords = data.totalRecords
    },
    CREATE_MT_ROUTER: (state, router) => {
        state.mtrouters.unshift(router)
    },
    UPDATE_MT_ROUTER: (state, route) => {
        for (let i = 0; i < state.mtrouters.length; i++) {
            if (state.mtrouters[i].id === route.id) {
                for (let field in state.mtrouters[i]) {
                    state.mtrouters[i][field] = route[field]
                }
                break
            }
        }
    },
    REMOVE_MT_ROUTER: (state, router) => {
        state.mtrouters = state.mtrouters.filter(r => r.id !== router.id)
    }
}

export const actions = {
    async getMtRouters({ commit }, params = {}) {
        let { _commit } = params
        if (typeof (_commit) === 'boolean' && _commit === false) return axios.get('/sms/routes', { params: params })
        await axios.get('/sms/routes', { params: params }).then(resp => {
            if (resp.status === 200) {
                commit("GET_MT_ROUTERS", resp.data)
            }
        })
    },
    async getMtRouter({ commit }, mtrouter) {
        return axios.get(`/sms/routes/${mtrouter.id}`)
    },
    async createMtRouter({ commit }, mtroute) {
        await axios.post('/sms/routes', mtroute).then(resp => {
            if (resp.status === 201) {
                commit('CREATE_MT_ROUTER', resp.data)
            }
        })
    },
    async updateMtRouter({ commit }, mtrouter) {
        await axios.put(`/sms/routes`, mtrouter)
            .then(resp => {
                if (resp.status === 200) {
                    commit('UPDATE_MT_ROUTER', resp.data)
                }
            })
    },
    async removeMtRouter({ commit }, mtroute) {
        await axios.delete(`/sms/routes/${mtroute.id}`)
            .then(resp => {
                if (resp.status === 204) {
                    commit('REMOVE_MT_ROUTER', mtroute)
                }
            })
    },
}
